import 'slick-carousel';

$(document).ready(() => {
  const carouselContainers = document.querySelectorAll('.js-intelligent-batteries-product-feature-images');

  if (carouselContainers === null || carouselContainers.length === 0) {
    return;
  }

  Array.forEach(carouselContainers, (container) => {
    $(container).slick({
      dots: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2500,
      speed: 1000,
      slidesToShow: 4,
      slidesToScroll: 1,
      lazyLoad: 'ondemand',
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
});
